
<mat-form-field  floatLabel="never">
  <mat-select class="goals-select" [placeholder]="activity.hint" [formControl]="activityControl"  [required]="activity.isRequired" [matTooltip]="getTooltipText(activity.ans)"  matTooltipPosition="above"  multiple panelClass="calc-dropdown-panel">
    <mat-option *ngFor="let option of activity['values']" [value]="option.value" [matTooltip]="option.name"  matTooltipPosition="right">
      {{option.name}}
    </mat-option>
  </mat-select>
  <mat-error class="m-top-8" *ngIf="activityControl.hasError('required')">{{'Required' | translate}}* </mat-error>

</mat-form-field>

